import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useAuthStore } from '../store/store';
import styles from '../styles/Login.module.css';
import { generateOTP, verifyOTP } from '../helper/helper';
import { useNavigate } from 'react-router-dom';

export default function Recovery() {
  const { email } = useAuthStore(state => state.auth);
  const [OTP, setOTP] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (email) {
      generateOTP(email)
        .then((OTP) => {
          console.log('OTP:', OTP);
          if (OTP) return toast.success('OTP has been sent to your email!');
          return toast.error('Problem while generating OTP!');
        })
        .catch((error) => {
          toast.error('Failed to send OTP');
          console.error(error);
        });
    } else {
      toast.error('No email found. Please start from the beginning.');
    }
  }, [email]);

  async function onSubmit(e) {
    e.preventDefault();
    try {
      const { status } = await verifyOTP({ email, code: OTP });
      if (status === 201) {
        toast.success('Verified successfully!');
        return navigate('/reset');
      }
    } catch (error) {
      toast.error('Wrong OTP! Check your email again.');
    }
  }

  function resendOTP() {
    if (!email) return toast.error('Email not found');

    const sentPromise = generateOTP(email);

    toast.promise(sentPromise, {
      loading: 'Sending...',
      success: <b>OTP has been sent to your email!</b>,
      error: <b>Could not send OTP!</b>,
    });

    sentPromise.then((OTP) => {
      console.log('Resent OTP:', OTP);
    });
  }

  return (
    <div className="container mx-auto">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="flex justify-center items-center h-screen">
        <div className={styles.glass}>
          <div className="title flex flex-col items-center">
            <h4 className="text-5xl font-bold">Recovery</h4>
            <span className="py-4 text-xl w-2/3 text-center text-gray-500">
              Enter OTP to recover password.
            </span>
          </div>

          <form className="pt-20" onSubmit={onSubmit}>
            <div className="textbox flex flex-col items-center gap-6">
              <div className="input text-center">
                <span className="py-4 text-sm text-left text-gray-500">
                  Enter 6-digit OTP sent to your email.
                </span>
                <input
                  onChange={(e) => setOTP(e.target.value)}
                  className={styles.textbox}
                  type="text"
                  placeholder="OTP"
                />
              </div>

              <button className={styles.btn} type="submit">
                Recover
              </button>
            </div>
          </form>

          <div className="text-center py-4">
            <span className="text-gray-500">
              Can't get OTP?{' '}
              <button onClick={resendOTP} className="text-red-500">
                Resend
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}


